import '@prizepicks/tailwind-config/index.css';
import * as Sentry from '@sentry/react';
import { RELEASE_VERSION, SENTRY_DSN } from '@bo-utils/environmentVariables';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

// eslint-disable-next-line no-restricted-imports
import { App } from './App';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { SplitFactory } from '@bo-components/split/SplitFactory';
import { getEnvironment } from '@bo-utils/environment';
import { getStore } from '@bo-store';

const environment = getEnvironment();

if (environment) {
  const {
    sentryReplaysOnErrorSampleRate = 1.0,
    sentryReplaysSessionSampleRate = 0,
    sentryTracesSampleRate = 0
  } = window.backoffice || {};

  Sentry.init({
    dsn: SENTRY_DSN,
    environment,
    release: RELEASE_VERSION,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.replayIntegration({
        beforeAddRecordingEvent: (event) => {
          // Do not capture fetch/xhr requests, if the response code is 200 or 201 (success) range
          if (
            event.data.tag === 'performanceSpan' &&
            (event.data.payload.op === 'resource.fetch' ||
              event.data.payload.op === 'resource.xhr') &&
            [200, 201].includes(event.data.payload.data?.statusCode as number)
          ) {
            return null;
          }
          return event;
        },
        blockAllMedia: true,
        maskAllText: false
      })
    ],
    replaysOnErrorSampleRate: sentryReplaysOnErrorSampleRate,
    replaysSessionSampleRate: sentryReplaysSessionSampleRate,
    tracesSampleRate: sentryTracesSampleRate
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <SplitFactory>
      <Provider store={getStore()}>
        <App />
      </Provider>
    </SplitFactory>
  </React.StrictMode>
);
